import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PdfDownloadService {
  private readonly http = inject(HttpClient);

  /** posts payload to url and saves returned pdf, file name from Content-Disposition is preferred over fallbackFileName */
  downloadPdf(
    url: string,
    fallbackFileName: string,
    payload: object = {}
  ): Observable<void> {
    return this.http
      .post(url, payload, { responseType: 'blob', observe: 'response' })
      .pipe(
        take(1),
        map(resp => {
          if (!resp.body) return;
          this.saveFile(
            resp.body,
            this.getFileNameFromHeader(resp) ?? fallbackFileName
          );
        })
      );
  }

  private saveFile(body: Blob, fileName: string): void {
    const blobUrl = URL.createObjectURL(
      new Blob([body], { type: 'application/pdf' })
    );
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  }

  private getFileNameFromHeader(resp: HttpResponse<Blob>): string | undefined {
    const disposition = resp.headers.get('Content-Disposition');
    const match = disposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : undefined;
  }
}
